/* eslint-disable */
export default class SmartAppBanner {
  init() {
    this.handleSmartAppBanner();
    this.closeSmartBanner();
    this.downloadApp();
  }

  downloadApp() {
    $(document).on('click', '#appBanner button.apple-btn, #appBanner button.android-btn', function () {
      window.location.href = $('#appBanner').attr('data-download-url');
    });
  }

  closeSmartBanner() {
    $(document).on('click', '#appBanner button.close', function () {
      $('#appBanner').slideUp(300, function () {
        $(this).remove();
        sessionStorage.setItem('shownSmartAppBanner', 'false');
      });
    });
  }

  detectUserAgent() {
    const userAgent = navigator.userAgent;
    const isApple = /iPhone|iPad|iPod/i.test(userAgent);
    const isAndroid = /Android/i.test(userAgent);

    return isApple || isAndroid;
  }

  handleSmartAppBanner() {
    const userAgent = this.detectUserAgent();
    const shownBanner = sessionStorage.getItem('shownSmartAppBanner');

    if (userAgent && (!shownBanner || shownBanner !== 'false')) {
      $('#appBanner').removeClass('d-none').addClass('d-flex');
    } else {
      $('#appBanner').removeClass('d-flex').addClass('d-none');
    }
  }
}
